import { DeviceOption } from '@/types/usermedia'

export const trimDeviceLabel = (device: string) => device.replace(/ *\([^)]*\) */g, '')

export const getMediaOptions = (devices: DeviceOption[] = []) => devices.map((device) => ({
  key: device.value, label: trimDeviceLabel(device.text), value: device.deviceId
}))
